import { render, staticRenderFns } from "./volumes.vue?vue&type=template&id=304b6420"
import script from "./volumes.vue?vue&type=script&lang=js"
export * from "./volumes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports